import { render, staticRenderFns } from "./purchase_link.vue?vue&type=template&id=0b7dcb84&"
import script from "./purchase_link.vue?vue&type=script&lang=js&"
export * from "./purchase_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports